<div class="modal-header">
  <h5 class="modal-title"><i class="far fa-pencil"></i>&nbsp;<ng-container i18n>Bulk Editing</ng-container></h5>
  <button (click)="close()" type="button" class="close" aria-label="Close" i18n-aria-label>
    <i class="far fa-times"></i>
  </button>
</div>

<div class="modal-body">
  <p class="text-muted" i18n>Only fields with a value will be updated for the selected tasks.</p>

  <form [formGroup]="form">
    <div class="row">
      <div class="col-md-6">
        <mat-form-field2 class="mat-block">
          <mat-label i18n>Task Name</mat-label>
          <input type="text" matInput formControlName="name" placeholder="Leave unchanged" i18n-placeholder />
          <mat-error *ngIf="form.get('name').hasError('minlength')">
            <ng-container i18n>Minimum length is</ng-container>&nbsp;
            <strong>{{ form.get('name').errors?.minlength.requiredLength }}</strong>
          </mat-error>
          <mat-error *ngIf="form.get('name').hasError('maxlength')">
            <ng-container i18n>Maximum length is</ng-container>&nbsp;
            <strong>{{ form.get('name').errors?.maxlength.requiredLength }}</strong>
          </mat-error>
          <mat-error *ngIf="form.get('name').hasError('allNumbers')">
            <ng-container i18n>Name cannot be numbers alone.</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>

      <div class="col-md-6">
        <mat-form-field2 class="mat-block">
          <input
            type="text"
            matInput
            formControlName="list"
            placeholder="Select Task List"
            i18n-placeholder
            [matAutocomplete]="taskListAutocomplete"
          />
          <mat-autocomplete #taskListAutocomplete="matAutocomplete">
            <mat-option *ngFor="let list of filteredLists | async" [value]="list">
              {{ list }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field2>
      </div>

      <div class="col-md-6">
        <mat-form-field2 class="mat-block">
          <app-mat-date-input
            formControlName="start"
            placeholder="Start Date & Time"
            i18n-placeholder
            [showTime]="true"
            [max]="form.get('due').value"
          ></app-mat-date-input>
          <span matPrefix><i class="fal fa-calendar"></i> </span>
          <mat-error *ngIf="form.get('start').hasError('max')">
            <ng-container i18n>Max value is</ng-container>&nbsp;
            <strong>{{ form.get('start').getError('max').max | epoch : 'datetime' }}</strong>
          </mat-error>
        </mat-form-field2>
      </div>

      <div class="col-md-6">
        <mat-form-field2 class="mat-block">
          <app-mat-date-input
            formControlName="due"
            placeholder="Due Date & Time"
            i18n-placeholder
            [showTime]="true"
            [min]="form.get('start').value"
          ></app-mat-date-input>
          <span matPrefix><i class="fal fa-calendar"></i> </span>
          <mat-error *ngIf="form.get('due').hasError('min')">
            <ng-container i18n>Min value is</ng-container>&nbsp;
            <strong>{{ form.get('due').getError('min').min | epoch : 'datetime' }}</strong>
          </mat-error>
        </mat-form-field2>
      </div>

      <div class="col-md-6">
        <app-timezone-select [ctrl]="form.get('timezone')"></app-timezone-select>
      </div>

      <div class="col-md-6">
        <mat-form-field2 class="mat-block">
          <mat-select formControlName="status" placeholder="Status" i18n-placeholder>
            <mat-option *ngFor="let status of statuses" [value]="status.value">
              {{ status.label }}
            </mat-option>
          </mat-select>
        </mat-form-field2>
      </div>

      <div class="col-md-6">
        <app-task-assignee-select
          [ctrl]="form.get('user_ids')"
          placeholder="Assignees"
          i18n-placeholder
        ></app-task-assignee-select>
      </div>

      <div class="col-md-6">
        <app-rental-select
          [ctrl]="form.get('rental_id')"
          [multiple]="false"
          label="Rental"
          i18n-label
          placeholder="Select Rentals"
          i18n-placeholder
        ></app-rental-select>
      </div>

      <div class="col-md-6 mb-3">
        <label i18n>Color</label>
        <app-color-boxes [ctrl]="form.get('color')" [colors]="colors" [boxSize]="20"></app-color-boxes>
      </div>

      <div class="col-md-12">
        <mat-form-field2 class="mat-block">
          <mat-label i18n>Task Notes</mat-label>
          <textarea
            matInput
            rows="3"
            cdkTextareaAutosize
            [cdkAutosizeMaxRows]="5"
            formControlName="notes"
            placeholder="Leave unchanged"
            i18n-placeholder
          ></textarea>
        </mat-form-field2>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="save(form)" type="button" class="btn btn-secondary-info" [disabled]="!hasChanges || form.invalid">
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>Save</ng-container>
  </button>
</div>
